import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Box } from '@mui/material'
import CustomList from './components/CustomList/index'
import AppDrawer from 'components/ui-kit/AppDrawer/index'
import { handleDrawerToggle } from 'redux-thunk/redux/slices/ham.slice'
import { getRole } from 'utils/common-services/session.services'
import { ROLES } from 'utils/constants/index'
import { fetchAdminInformation } from 'redux-thunk/thunk/admin.thunk'
import { adminSidebarOptions, operatorSidebarOptions, permissionMap } from './sidebarOptions'
import { useSidebarController } from './controller/useSidebarController'

const Sidebar = () => {
  const dispatch = useDispatch()
  const { t, location, expandedMenuItem, handleDrawerOptions } = useSidebarController()

  const isSideBarOpen = useSelector(state => state.ham.openHam)
  const { adminUserDetails, loginData } = useSelector(state => state.auth)
  const isAdmin = getRole() === ROLES.ADMIN
  const sidebarLabel = isAdmin ? adminUserDetails?.firstName : loginData?.name
  const [filteredSidebarOptions, setFilteredSidebarOptions] = useState([])

  useEffect(() => {
    dispatch(fetchAdminInformation())
  }, [isAdmin])

  useEffect(() => {
    if (adminUserDetails?.permissions) {
      const permissions = adminUserDetails.permissions

      const options = (isAdmin ? adminSidebarOptions : operatorSidebarOptions).map(option => {
        if (option.label === 'Report') {
          const filteredSubMenus = option.subMenus.filter(submenu => {
            const submenuPermissionKey = permissionMap[submenu.label]
            return permissions[submenuPermissionKey]?.includes('read')
          })
          if (filteredSubMenus.length > 0) {
            return {
              ...option,
              subMenus: filteredSubMenus
            }
          }
          return null
        } else {
          let hasPermission = permissions[permissionMap[option.label]]?.includes('read')

          if (option.subMenus && option.subMenus.length > 0) {
            const subMenuPermissions = option.subMenus.map(submenu => {
              const submenuPermissionKey = permissionMap[submenu.label] || ''
              const submenuHasPermission = permissions[submenuPermissionKey]?.includes('read')
              return submenuHasPermission
            })
            const hasSubmenuPermission = subMenuPermissions.some(Boolean)
            hasPermission = hasPermission || hasSubmenuPermission
          }
          return hasPermission ? option : null
        }
      }).filter(Boolean)

      setFilteredSidebarOptions(options)
    }
  }, [adminUserDetails, isAdmin])

  return (
    <AppDrawer
      testid='sidebar'
      openDrawer={isSideBarOpen}
      handleDrawer={() => dispatch(handleDrawerToggle())}
      text={sidebarLabel}
    >
      <Box>
        <CustomList
          t={t}
          location={location}
          list={filteredSidebarOptions}
          handleDrawerOptions={handleDrawerOptions}
          expandedMenuItem={expandedMenuItem}
        />
      </Box>
    </AppDrawer>
  )
}

export default Sidebar
